import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import { AiOutlineClose } from 'react-icons/ai';
import { useRecordPath } from '../Context/Context.js';

function Companies() {
  const [companies, setCompanies] = useState([]);
  const [companiesList, setCompaniesList] = useState([]);
  const [selectedCompanyList, setSelectedCompanyList] = useState([]);
  const [showModal, setShowModal] = useState(false); 

  const {
      pathRecord,
      setPathRecord,
      showStation,
      setShowStation,
      showpath,
      setShowpath,
      hoveredPath,
      setHoveredPath,
      canvasWidth,
      setCanvasWidth,
      cameraOffset,
      setCameraOffset,
      showParking,
      setShowParking,
      selectedParking,
      setSelectedParking,
      selectedBot,
      setSelectedBot,
      selectedPath,
      setSelectedPath,
      selectedZone = [],
      setSelectedZone,
      showCartParking,
      setShowCartParking,
      selectedCartParking,
      setSelectedCartParking,
      selectedStation,
      setSelectedStation,
      selectedPeople,
      setSelectedPeople,
      showBots,
      showPeople,
      setShowPeople,
      setShowBots,
      showAprilTags,
      setShowAprilTags,
      showZone,
      setShowZone,
      showMaterials,
      setShowMaterials,
      stationRecord,
      setStationRecord,
      stationMarkedCoordinate,
      setStationMarkedCoordinate,
      tracePath,
      setTracePath,
      tagName,
      settagName,
      botTraceArray,
      setBotTraceArray,
      jitterbotCoordinates,
      setjitterbotCoordinates,
      parkingSpaceCoordinates,
      setParkingSpaceCoordinates,
      startParkingSpaceRecord,
      setStartParkingSpaceRecord,
      startCartParkingSpaceRecord,
      setStartCartParkingSpaceRecord,
      cartParkingSpaceCoordinates,
      setCartParkingSpaceCoordinates,
      selectedParkingSpace,
      setSelectedParkingSpace,
      traceTagName,
      settraceTagName,
      traceStation,
      setTraceStation,
      stationTraceArray,
      setStationTraceArray,
      stationTraceCoordinate,
      setStationTraceCoordinate,
      AprilTags,
      setAprilTags,
      AprilTagsCoordinates, 
      setAprilTagsCoordinates,
      isDejitterActive, setIsDejitterActive,
      DeJitterParam, setDeJitterParam,
      lastDeJitterValue, setLastDeJitterValue
    } = useRecordPath();
  const navigate = useNavigate();
  const handleSendRequest = async () => {
    const userUid = JSON.parse(window.sessionStorage.getItem('data'))?.uid;
  
    if (!userUid || selectedCompanyList.length === 0) {
      toast.error("Please select at least one company.");
      return;
    }
  
    await toast.promise(
      axios.post(
        'https://drobot-admin-v2-a2def93839bb.herokuapp.com/access_request',
        {
          userUid: userUid,
          companylist: selectedCompanyList,
        },
        {
          withCredentials: true,
        }
      ),
      {
        loading: 'Sending access request...',
        success: 'Request sent successfully!',
        error: 'Error sending request. Please try again.',
      }
    );
  
    // Optional: Clean up UI
    setShowModal(false);
    setSelectedCompanyList([]);
  };
  

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await axios.post(
          'https://drobot-admin-v2-a2def93839bb.herokuapp.com/companies',
          {
            userUid: JSON.parse(window.sessionStorage.getItem('data')).uid,
          },
          {
            withCredentials: true,
          }
        );

        const data = response.data;
        setCompanies(data.companies);
      } catch (error) {
        console.error('Error fetching companies:', error);
        toast.error('Error fetching companies. Please try again.');
      }
    };

    fetchCompanies();
  }, []);

  const setCompanyData = async (companyName) => {
    toast.promise(
      axios
        .post(
          'https://drobot-admin-v2-a2def93839bb.herokuapp.com/getcompanydata',
          { company: companyName }
        )
        .then(async (response) => {
          const data = response.data;
          window.sessionStorage.setItem(
            'stationData',
            JSON.stringify(data.stationdata)
          );
          window.sessionStorage.setItem(
            'companyData',
            JSON.stringify(data.companydata)
          );
          window.sessionStorage.setItem(
            'AprilTagsData',
            JSON.stringify(data.apriltagsdata)
          );
          window.sessionStorage.setItem('companyName', companyName);

          window.sessionStorage.setItem(
            'botParkingSpaceData',
            JSON.stringify(
              data.stationdata
                .map((station) => {
                  if (station.bot_parking != null) {
                    return {
                      ...station.bot_parking,
                      station: station.stationName,
                    };
                  }
                  return null;
                })
                .filter((parking) => parking !== null)
            )
          );

          await setpathData(companyName);
          await setzoneData(companyName);
          await fetchMappings(companyName);
          navigate('/home');
          return 'Company data fetched successfully!';
        }),
      {
        loading: 'Fetching company data...',
        success: 'Company data fetched successfully!',
        error: 'Error fetching company data. Please try again.',
      }
    );
  };

  const setpathData = async (companyName) => {
    const data = await axios.post(
      'https://drobot-admin-v2-a2def93839bb.herokuapp.com/getpathdata',
      { company: companyName }
    );
    window.sessionStorage.setItem('pathData', JSON.stringify(data.data));
  };
  const fetchMappings = async (companyName) => {
    try {
      const botResponse = await axios.post(
        'https://drobot-admin-v2-a2def93839bb.herokuapp.com/getBotMapping',
        {
          companyName: companyName,
        }
      );
      window.sessionStorage.setItem(
        'botMapping',
        JSON.stringify(botResponse.data)
      );

      const materialResponse = await axios.post(
        'https://drobot-admin-v2-a2def93839bb.herokuapp.com/getMaterialsMapping',
        {
          companyName: companyName,
        }
      );
      window.sessionStorage.setItem(
        'MaterialMapping',
        JSON.stringify(materialResponse.data)
      );
      const peopleResponse = await axios.post(
        'https://drobot-admin-v2-a2def93839bb.herokuapp.com/getPeopleMapping',
        {
          companyName: companyName,
        }
      );
      window.sessionStorage.setItem(
        'PeopleMapping',
        JSON.stringify(peopleResponse.data)
      );
    } catch (error) {
      console.error('Error fetching mappings:', error);
    }
  };

  const setzoneData = async (companyName) => {
    const data = await axios.post(
      'https://drobot-admin-v2-a2def93839bb.herokuapp.com/getzonedata',
      { company: companyName }
    );
    window.sessionStorage.setItem('zoneData', JSON.stringify(data.data));
  };

  return (
    <div className="w-full h-screen bg-[#015d81] flex justify-center items-center">
      <Toaster />
      <div className="bg-[#015d81] p-8 rounded-lg flex flex-col items-center gap-6">
        <img
          src="svgs/drobot_logo.svg"
          alt="Drobot"
          className="mb-6 w-[150px]"
        />

        <button
          className="bg-[#015d81] text-white font-semibold text-lg border-2 border-white rounded-lg px-4 py-2 hover:bg-[#0178a3] transition-all duration-300 cursor-pointer"
          onClick={async () => {
            setShowModal(true);
            const companylist = await axios.get(
              'https://drobot-admin-v2-a2def93839bb.herokuapp.com/getcompanylist'
            );
            console.log(companylist.data);

            setCompaniesList(companylist.data);
          }}
        >
          +Add company
        </button>

        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white w-[90%] sm:w-[70%] lg:w-[40vw] max-h-[90vh] overflow-y-auto rounded-2xl p-6 shadow-2xl relative">
              {/* Close Button */}
              <button
                className="absolute top-3 right-4 text-2xl font-bold text-gray-500 hover:text-black transition"
                onClick={() => setShowModal(false)}
              >
                &times;
              </button>

              {/* Title */}
              <h2 className="text-2xl font-bold mb-6 text-center text-[#015d81]">
                Select a Company
              </h2>

              {/* Company List */}
              <div className="flex flex-wrap justify-center gap-3 mb-6">
                {companiesList.length==0?<span className='text-xl font-semibold text-[#015d81]'>...Loading Companies</span>:companiesList.map((company, index) => (
                  <div
                    key={index}
                    className={`px-4 py-2 rounded-md text-lg font-medium cursor-pointer transition-all duration-200
              ${
                selectedCompanyList.includes(company)
                  ? 'bg-gray-300 text-gray-600 cursor-not-allowed'
                  : 'bg-[#015d81] text-white hover:bg-[#0178a3]'
              }`}
                    onClick={() => {
                      if (!selectedCompanyList.includes(company)) {
                        setSelectedCompanyList([
                          ...selectedCompanyList,
                          company,
                        ]);
                      }
                    }}
                  >
                    {company}
                  </div>
                ))}
              </div>

              {/* Divider */}
              <div className="border-t border-gray-300 my-4"></div>

              {/* Selected Companies */}
              <h2 className="text-2xl font-bold mb-4 text-center text-[#015d81]">
                Selected Companies
              </h2>
              <div className="flex flex-wrap justify-center gap-4">
                {selectedCompanyList.map((company, index) => (
                  <div
                    key={index}
                    className="relative bg-[#015d81] text-white px-4 py-2 rounded-md text-lg font-medium shadow-md flex items-center justify-center  transition-all"
                  >
                    {/* Company Name */}
                    {company}

                    {/* Cross Button Outside the Chip */}
                    <button
                      className="absolute -top-2 -right-2 bg-white border-[#015d81] border-[1px] text-[#015d81] rounded-full p-1 shadow-md hover:bg-red-500 hover:text-white transition-all"
                      onClick={() =>
                        setSelectedCompanyList(
                          selectedCompanyList.filter((c) => c !== company)
                        )
                      }
                    >
                      <AiOutlineClose size={14} />
                    </button>
                  </div>
                ))}
              </div>
                <div className="border-t border-gray-300 my-4"></div>
            <div className="flex justify-end mt-4">
      <button
        className="bg-[#015d81] text-white px-6 py-2 rounded-md text-lg font-semibold hover:bg-[#0178a3] transition-all duration-300"
        onClick={() => handleSendRequest()}
      >
        Send Request
      </button>
    </div>
            </div>
          </div>
        )}

        <div className="bg-white w-[90%] sm:w-[70%] lg:w-[55vw] h-[60vh] overflow-y-auto shadow-lg rounded-lg flex flex-col items-center gap-4 p-6">
          <p className="text-black-600 text-xl mb-4 font-semibold">
            Select a company to view details:
          </p>

          <div className="w-full flex flex-wrap justify-center items-center gap-6">
            {companies.map((company) => (
              <div
                key={company.id}
                className="h-[5rem] w-[12rem] bg-[#015d81] border-black border rounded-lg flex justify-center items-center text-xl font-semibold text-white shadow-lg hover:bg-[#0178a3] hover:scale-105 transition-all duration-300 cursor-pointer"
                onClick={() => setCompanyData(company['Company Name'])}
              >
                {company['Company Name']}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Companies;
